import React from 'react';
import PropTypes from 'prop-types';
import css from './FormGroup.module.scss';
import DeleteButton from "../../Button/DeleteButton.jsx";

const FormGroupInnerChild = ({
  title,
  className,
  children,
  onRemove,
  style,
}) => {
  return (
    <div className={`${className} ${css.formGroupInnerChild}`} style={style}>
      <div className={title ? css.header : css.noTitleHeader}>
        {title && <h5 className={css.formGroupTitle}>{title}</h5>}
        {onRemove &&
          <DeleteButton onClick={onRemove}/>
        }
      </div>
      <div className={css.formGroupInnerChildForm}>
        {children}
      </div>
    </div>
  );
};

FormGroupInnerChild.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  onRemove: PropTypes.func,
  showRemove: PropTypes.bool
};

export default FormGroupInnerChild;
